import { render, staticRenderFns } from "./StatList.vue?vue&type=template&id=517d448b&scoped=true"
import script from "./StatList.vue?vue&type=script&lang=js"
export * from "./StatList.vue?vue&type=script&lang=js"
import style0 from "./StatList.vue?vue&type=style&index=0&id=517d448b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517d448b",
  null
  
)

export default component.exports